import { toast } from 'react-toastify';
import { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import * as utils from "../utils/utils.js";

export default function Login({ setCurrentUser }) {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate ();

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  }

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  }

  const handleSubmit = (e) => {
    // Prevent the browser from reloading the page
    e.preventDefault();

    // Get the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = JSON.stringify(Object.fromEntries(formData.entries()));

    // Send to API
    login(formJson);
  }

  // Save prefs in DB
  async function login(data) { 
    fetch(process.env.REACT_APP_API_SERVER + '/api/auth/login', { 
      method: 'post', 
      headers: {'Content-Type': 'application/json'},
      body: data 
    })
    .then(response => response.json())
    .then(data => confirmation(data));
    return;
  }

  // Display confirmation message
  const confirmation = (data) => {
    if (data.token) {
      toast.success('Connexion réussie 🎉', {
        autoClose: 300,
        onClose: () => {
          // store token
          utils.setWithExpiry('motus_access_token', data.token, 86400000);
          utils.setWithExpiry('motus_user_id', data.user.id, 86400000);

          //localStorage.setItem('motus_access_token', data.token);
          //localStorage.setItem('motus_user_id', data.user.id);
          setCurrentUser({id:data.user.id, token: data.token});
          navigate('/game/maxword');
        }
      });
    }
    else {
			toast.error("Erreur d'identification ou email non confirmé 😱", {
        autoClose: 5000
      });
      console.log("Erreur de login");
    }
  }
    
	return(
		<>
			<h2>Connectez-vous pour jouer</h2>

			<form method="post" onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="nick">Email : </label>
          <input type="text" name="email" value={email} onChange={e => handleChangeEmail(e)} />
        </div>

        <div className="field">
          <label htmlFor="nick">Password : </label>
          <input type={showPassword ? "text" : "password"} name="password" value={password} onChange={e => handleChangePassword(e)} />
          <button
            type="button"
            className="password-visibility-button"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>
        </div>

				<div className="field">
          <input type="submit" value="Login" />
        </div>
			</form>

      <p><Link to="/authent/lostpwd">Mot de passe perdu ?</Link></p>
      <p>Si vous n'avez pas de compte, <Link to="/authent/register">créez-en un</Link>.</p>
		</>
	);
}
